"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioErrorsToError = exports.getPaths = exports.io = void 0;
const tslib_1 = require("tslib");
const io = tslib_1.__importStar(require("io-ts"));
exports.io = io;
const fp_1 = require("./fp");
/**
 * Convert an io-ts validation into an Either with a list of somewhat
 * human-readable strings on the left.
 */
exports.getPaths = (v) => {
    return fp_1.pipe(v, fp_1.E.mapLeft(errors => {
        return errors.map(error => {
            const { type, actual } = error.context.slice(-1)[0];
            const actualValue = typeof actual === "object" ? JSON.stringify(actual, null, 2) : actual;
            const path = error.context
                .reduce((p, { key }) => [...p, key], [])
                .filter(Boolean)
                .filter(errorKey => isNaN(parseInt(errorKey, 10)));
            return `${path.join(".")} is expected to be type ${type.name}, but is actually ${actualValue}, type ${typeof actual}`;
        });
    }));
};
/**
 * Convert an io-ts validation into an Either with a somewhat
 * human-readable error on the left.
 */
exports.ioErrorsToError = (v) => {
    return fp_1.pipe(v, exports.getPaths, fp_1.E.mapLeft(errorStrings => new Error(`Validation Error: ${errorStrings.join("\n")}`)));
};
//# sourceMappingURL=io.js.map